import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import dynamic from 'next/dynamic'
import Trans from 'next-translate/Trans'
import { articleLoader } from '@shared/libs/allLoader'
import CustomLink from '@shared/components/customLink'
import { useRouter } from 'next/router'
import ArticleSmall from '@shared/components/article/articleSmall'
import { RightArrow } from '@shared/components/ctIcons'
import NoData from '@shared/components/noData'
const PlayerInfo = dynamic(() => import('@shared/components/player/playerInfo'))
const ArticleSearch = dynamic(() => import('@shared/components/article/articleSearch'), { loading: () => articleLoader(['g']) })
const RecentForm = dynamic(() => import('@shared/components/player/recentForm'))
const StatsTable = dynamic(() => import('@shared/components/player/playerOverview/statsTable'))

const PlayerOverview = ({ playerData, playerStatsData, article, recentFormData }) => {
  const router = useRouter()

  return (
    <>
      {!playerData && !playerStatsData && !article && !recentFormData ? (
        <NoData />
      ) : (
        <>
          <Row>
            <PlayerInfo data={playerData} />
          </Row>
          {playerStatsData?.t20 && playerStatsData?.odi && playerStatsData?.test && (
            <StatsTable playerData={playerData} playerStatsData={playerStatsData} />
          )}
          {recentFormData && recentFormData.length !== 0 && <RecentForm recentFormData={recentFormData} playerData={playerData} />}
          {article?.aResults?.length > 0 && (
            <Row className="content-visibility-auto">
              <h3 className="small-head">
                <Trans i18nKey="common:PlayerNews" />
              </h3>
              {article?.aResults?.slice(0, 6)?.map((a, i) => {
                return (
                  <React.Fragment key={i + a?._id}>
                    <Col lg={4} sm={6} id={a?._id} className="d-sm-block d-none">
                      <ArticleSearch data={a} isVideo={a?.__typename === 'oVideoData'} />
                    </Col>

                    <Col lg={4} sm={6} id={a?._id} className="d-sm-none d-block">
                      <ArticleSmall data={a} isVideo={a?.__typename === 'oVideoData'} />
                    </Col>
                  </React.Fragment>
                )
              })}
              <div className="text-center theme-text mb-3">
                <CustomLink href={`${router.asPath}/news`} prefetch={false}>
                  <a className="theme-btn btn btn-primary">
                    <Trans i18nKey="common:More" /> <Trans i18nKey="common:News" />
                    <RightArrow />
                  </a>
                </CustomLink>
              </div>
            </Row>
          )}
        </>
      )}
      {/* <Row>
          <PlayerInfo data={playerData} />
        </Row>
        <StatsTable playerData={playerData} playerStatsData={playerStatsData} />
        {recentFormData && recentFormData.length !== 0 && (

          <RecentForm recentFormData={recentFormData} playerData={playerData} />
        )
        }
        {
          article?.aResults?.length > 0 && (
            <Row>
              <h3 className="small-head">
                <Trans i18nKey="common:PlayerNews" />
              </h3>
              {article?.aResults?.slice(0, 6)?.map((a, i) => {
                return (
                  <React.Fragment key={i + a?._id}>
                    <Col lg={4} sm={6} id={a?._id} className="d-sm-block d-none">
                      <ArticleSearch data={a} isVideo={a?.__typename === 'oVideoData'} />
                    </Col>

                    <Col lg={4} sm={6} id={a?._id} className="d-sm-none d-block">
                      <ArticleSmall data={a} isVideo={a?.__typename === 'oVideoData'} />
                    </Col>
                  </React.Fragment>
                )
              })}
              <div className="text-center theme-text mb-3">
                <CustomLink href={`/${router.asPath}/news`} prefetch={false}>
                  <a className="theme-btn btn btn-primary">
                    <Trans i18nKey="common:More" /> <Trans i18nKey="common:News" />
                    <RightArrow />
                  </a>
                </CustomLink>
              </div>
            </Row>
          )
        } */}
    </>
  )
}

PlayerOverview.propTypes = {
  playerData: PropTypes.object,
  article: PropTypes.object,
  playerStatsData: PropTypes.object,
  recentFormData: PropTypes.array
}

export default PlayerOverview
